/**
 * UNE ILLUSTRATION, ET SON ABSENCE (design §3).
 *
 * L'ABSENCE EST L'ÉTAT PAR DÉFAUT, et c'est tout ce composant. Les images se dessinent hors du
 * produit et se posent à la main, aventure par aventure (§6.1 du brief) : la plupart des aventures
 * n'en auront aucune pendant des mois. Rien ne s'affiche alors — pas de cadre vide, pas de
 * rectangle gris, pas de silhouette générique en attendant.
 *
 * ET SI L'IMAGE EXISTE MAIS NE CHARGE PAS — fichier effacé, réseau coupé —, elle se retire d'
 * elle-même : une vignette cassée au milieu d'un manuscrit est pire que pas de vignette.
 *
 * Le rapport de forme est réservé AVANT le chargement (`aspect-ratio`), sans quoi le texte sauterait
 * quand l'image arrive — et un texte qui saute pendant qu'on le lit est un texte qu'on relit.
 */
import { useState } from "react";

export type FormeDIllustration = "bandeau" | "portrait" | "plan";

const RAPPORTS: Record<FormeDIllustration, string> = {
  bandeau: "16 / 9",
  portrait: "1 / 1",
  plan: "3 / 2"
};

export function Illustration({
  url,
  legende,
  forme = "bandeau",
  className
}: {
  url: string | null | undefined;
  /** Ce que l'image montre, pour qui ne la voit pas. Jamais « illustration » : le nom du lieu, de
   * la créature, du nœud. */
  legende: string;
  forme?: FormeDIllustration;
  className?: string;
}) {
  const [cassee, poseCassee] = useState(false);
  if (!url || cassee) return null;

  return (
    <figure className={className ? `vignette vignette--${forme} ${className}` : `vignette vignette--${forme}`}>
      <img
        src={url}
        alt={legende}
        loading="lazy"
        decoding="async"
        style={{ aspectRatio: RAPPORTS[forme] }}
        onError={() => poseCassee(true)}
      />
    </figure>
  );
}
